import {
  and,
  isBooleanControl,
  isDateControl,
  isEnumControl,
  isIntegerControl,
  isNumberControl,
  isNumberFormatControl,
  isOneOfEnumControl,
  isStringControl,
  isTimeControl,
  optionIs,
} from '@jsonforms/core';
import { ControlConfiguration } from '@components/uploadForm/Types/ControlConfiguration';

export const controlConfigurations: ControlConfiguration[] = [
  { controlFunc: isBooleanControl, rank: 2, cell: 'BooleanCell' },
  {
    controlFunc: and(isBooleanControl, optionIs('toggle', true)),
    rank: 3,
    cell: 'BooleanToggleCell',
  },
  { controlFunc: isDateControl, rank: 2, cell: 'DateCell' },
  { controlFunc: isEnumControl, rank: 2, cell: 'EnumCell' },
  { controlFunc: isOneOfEnumControl, rank: 2, cell: 'OneOfEnumCell' },
  { controlFunc: isNumberControl, rank: 2, cell: 'IntegerCell' },
  { controlFunc: isNumberFormatControl, rank: 4, cell: 'NumberCell' },
  { controlFunc: isIntegerControl, rank: 2, cell: 'NumberFormatCell' },
  { controlFunc: isNumberControl, rank: 3, cell: 'MaskedNumberFormatCell' },
  { controlFunc: isStringControl, rank: 1, cell: 'TextCell' },
  { controlFunc: isTimeControl, rank: 2, cell: 'TimeCell' },
];
